module.exports = __webpack_public_path__ + "img/n4.96f14465.png";